(() => {
  // Keep homepage badges as real product links even if Judge.me's badge handler
  // would otherwise try to scroll to a widget on the homepage.
  document.addEventListener("click", event => {
    const link = event.target.closest?.("[data-mix-review-link]");
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);

  if (new URLSearchParams(window.location.search).get("write_review") !== "1") return;
  const section = document.getElementById("bag-reviews");
  const widget = document.getElementById("judgeme_product_reviews");
  const status = section?.querySelector("[data-review-loading]");
  if (!section || !widget) return;
  section.scrollIntoView({ block: "start" });
  if (status) status.hidden = false;

  let done = false;
  let timer;
  const observer = new MutationObserver(openForm);
  function openForm() {
    if (done) return;
    // Legacy and current widgets both expose a visible Write a review action.
    const button = [...widget.querySelectorAll('button, a, [role="button"]')].find(el =>
      (el.matches(".jdgm-write-rev-link") || /^write a review$/i.test(el.textContent.trim())) &&
      el.getClientRects().length && getComputedStyle(el).visibility !== "hidden" &&
      !el.disabled && el.getAttribute("aria-disabled") !== "true"
    );
    if (!button) return;
    done = true;
    observer.disconnect();
    clearTimeout(timer);
    if (status) status.hidden = true;
    button.click();
  }
  observer.observe(widget, { childList: true, subtree: true, attributes: true });
  timer = setTimeout(() => {
    if (done) return;
    observer.disconnect();
    if (status) status.textContent = "The review form hasn’t loaded. Please reload this page to try again.";
  }, 30000);
  openForm();
})();
